import graphQLAdapter from "@/adapters/graphQL.adapter.js";
import VariantCharacter from "@/entities/variantCharacter.entity.js";

/**
 * VariantCharacter Service Class
 *
 * @export
 * @class
 */
export default class {
  constructor () {
    // eslint-disable-next-line
    this.adapter = new graphQLAdapter();
    this.getVariantCharacter = getVariantCharacter.bind(this);
    this.variantCharacterCreate = variantCharacterCreate.bind(this);
    this.variantCharacterUpdate = variantCharacterUpdate.bind(this);
    this.variantCharacterDelete = variantCharacterDelete.bind(this);
  }

  async get (options) {
    await this.adapter.init();
    const res = await this.getVariantCharacter(options);
    return res.data.variantCharacter === null
      ? res.data.variantCharacter
      : VariantCharacter.fromJson(res.data.variantCharacter);
  }
  async create (options) {
    await this.adapter.init();
    const res = await this.variantCharacterCreate(options);
    return !res.data.variantCharacterCreate
      ? res.data.variantCharacterCreate
      : VariantCharacter.fromJson(res.data.variantCharacterCreate);
  }
  async update (options) {
    await this.adapter.init();
    const res = await this.variantCharacterUpdate(options);
    return !res.data.variantCharacterUpdate
      ? res.data.variantCharacterUpdate
      : VariantCharacter.fromJson(res.data.variantCharacterUpdate);
  }
  async delete (options) {
    await this.adapter.init();
    const res = await this.variantCharacterDelete(options);
    return !res.data.variantCharacterDelete
      ? res.data.variantCharacterDelete
      : VariantCharacter.fromJson(res.data.variantCharacterDelete);
  }
}

function getVariantCharacter (options = {}) {
  const query = `
    query ($id: ID!) {
      variantCharacter(variantCharacterId: $id) {
        id
        imageUrl
        imageUrlForTablet
        managementCode1
        managementCode2
        inputCode
        sortNumber
        variantCharacterGroup {
          id
          font
          code
          searchConditions
        }
      }
    }
  `;
  return this.adapter.query(query, options);
}

function variantCharacterCreate (options = {}) {
  const mutation = `
    mutation ($input: VariantCharacterInput!) {
      variantCharacterCreate(variantCharacter: $input) {
        id
        imageUrl
        imageUrlForTablet
        managementCode1
        managementCode2
        inputCode
        sortNumber
        variantCharacterGroup {
          id
          font
          code
          searchConditions
        }
      }
    }
  `;
  return this.adapter.mutation(mutation, options);
}

function variantCharacterUpdate (options = {}) {
  const mutation = `
    mutation ($id: ID!, $input: VariantCharacterInput!) {
      variantCharacterUpdate(variantCharacterId: $id, variantCharacter: $input) {
        id
        imageUrl
        imageUrlForTablet
        managementCode1
        managementCode2
        inputCode
        sortNumber
        variantCharacterGroup {
          id
          font
          code
          searchConditions
        }
      }
    }
  `;
  return this.adapter.mutation(mutation, options);
}

function variantCharacterDelete (options = {}) {
  const mutation = `
    mutation ($id: ID!) {
      variantCharacterDelete(variantCharacterId: $id) {
        id
        imageUrl
        imageUrlForTablet
        managementCode1
        managementCode2
        inputCode
        sortNumber
        variantCharacterGroup {
          id
          font
          code
          searchConditions
        }
      }
    }
  `;
  return this.adapter.mutation(mutation, options);
}
